import _Modal from "antd-mobile/es/components/modal";
import _Popup from "antd-mobile/es/components/popup";
import _Input from "antd-mobile/es/components/input";
import _Button from "antd-mobile/es/components/button";
import _Toast from "antd-mobile/es/components/toast";
import _Form from "antd-mobile/es/components/form";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { css } from 'emotion';
import { Checkbox } from 'antd-mobile-v2';
import CopyToClipboard from 'react-copy-to-clipboard';
import './index.less';
import lineImg from '@/images/prize_line.png';
import closeImg from '@/images/modal_close.png';
import closeIcon from '@/images/close_btn.png';
import successImg from '@/images/lottery_success.png';
import closeEyeImg from '@/images/close_eye.png';
import openEyeImg from '@/images/open_eye.png';
export default function LotteryModal(props) {
  var _Form$useForm = _Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var submit = props.submit,
    prizeInfo = props.prizeInfo,
    closeModal = props.closeModal,
    openCascader = props.openCascader,
    _props$location = props.location,
    location = _props$location === void 0 ? [] : _props$location;
  var type = prizeInfo.type,
    name = prizeInfo.name,
    imgUrl = prizeInfo.imgUrl,
    cardId = prizeInfo.cardId,
    cardSecret = prizeInfo.cardSecret;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    infoModal = _useState2[0],
    setInfoModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    stateModal = _useState4[0],
    setStateModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    tipModal = _useState6[0],
    setTipModal = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    quitModal = _useState8[0],
    setQuitModal = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    successTip = _useState10[0],
    setSuccessTip = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    checkState = _useState12[0],
    setCheckState = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showSecret = _useState14[0],
    setShowSecret = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    hasError = _useState16[0],
    setHasError = _useState16[1]; // useEffect(() => {
  //   if (location.length) {
  //     setHasError(false);
  //   }
  // }, [location]);
  var checkLocation = function checkLocation() {
    if (location.length === 0) {
      setHasError(true);
    } else {
      setHasError(false);
    }
  };
  var openStateModal = function openStateModal() {
    setStateModal(true);
  };
  var closeStateModal = function closeStateModal() {
    setStateModal(false);
  };
  var openTipModal = function openTipModal() {
    setTipModal(true);
  };
  var closeTipModal = function closeTipModal() {
    setTipModal(false);
  };
  var openQuitModal = function openQuitModal() {
    setQuitModal(true);
  };
  var closeQuitModal = function closeQuitModal() {
    setQuitModal(false);
  };
  var writeInfo = function writeInfo() {
    setInfoModal(true);
  };
  var triggerSecret = function triggerSecret() {
    setShowSecret(!showSecret);
  };
  var onSubmit = function onSubmit(_ref) {
    var state = _ref.state;
    form.validateFields().then(function (formValues) {
      // if (location.length === 0) {
      //   setHasError(true);
      // }
      // setHasError(false);
      if (state || checkState) {
        setCheckState(true);
        setTipModal(false);
        submit(formValues).then(function (res) {
          if (res && res.code === 200) {
            setSuccessTip(true);
          }
        });
      } else {
        openTipModal();
      }
    }).catch(function (error) {
      // checkLocation();
      console.log(error);
    });
  };
  var checkMobile = function checkMobile(rule, value) {
    if (value) {
      if (value.match(/^1\d{10}$/)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('请输入正确的手机号'));
    }
    return Promise.reject(new Error('请填写手机号'));
  };
  var stateContent = React.createElement("div", {
    className: stateModalContCls
  }, React.createElement("div", {
    className: "title"
  }, "\u300A\u4E2A\u4EBA\u4FE1\u606F\u6388\u6743\u58F0\u660E\u300B"), React.createElement("img", {
    src: closeIcon,
    onClick: closeStateModal
  }), React.createElement("div", {
    className: "desc"
  }, "\u6211\u4EEC\u975E\u5E38\u91CD\u89C6\u7528\u6237\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u5728\u60A8\u586B\u5199\u5956\u54C1\u90AE\u5BC4\u4FE1\u606F\u65F6\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002\u6211\u4EEC\u5E0C\u671B\u901A\u8FC7\u672C\u58F0\u660E\u5411\u60A8\u8BF4\u660E\uFF0C\u6211\u4EEC\u5982\u4F55\u6536\u96C6\u3001\u4F7F\u7528\u3001\u5B58\u50A8\u3001\u4FDD\u62A4\u8FD9\u4E9B\u4FE1\u606F\u3002", React.createElement("span", {
    style: {
      fontWeight: 500,
      color: '#161823'
    }
  }, "\u5728\u586B\u5199\u672C\u95EE\u5377\u76F8\u5173\u4FE1\u606F\u524D\uFF0C\u8BF7\u60A8\u52A1\u5FC5\u4ED4\u7EC6\u9605\u8BFB\u672C\u58F0\u660E\u3002\u60A8\u4E00\u65E6\u4E3B\u52A8\u5728\u76F8\u5E94\u9875\u9762\u63D0\u4EA4\u4FE1\u606F\uFF0C\u5373\u610F\u5473\u7740\u60A8\u540C\u610F\u6211\u4EEC\u6309\u7167\u672C\u58F0\u660E\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u59D3\u540D\u3001\u8054\u7CFB\u65B9\u5F0F\u3001\u5730\u5740\u4FE1\u606F\u5E76\u540C\u610F\u7B7E\u7F72\u672C\u300A\u4E2A\u4EBA\u4FE1\u606F\u53D7\u6743\u58F0\u660E\u300B")), React.createElement("div", {
    style: {
      fontWeight: 500,
      color: '#161823'
    }
  }, "\u4E00\u3001\u4E2A\u4EBA\u4FE1\u606F\u7684\u6536\u96C6\u548C\u4F7F\u7528"), React.createElement("div", null, "1\u3001\u6211\u4EEC\u63D0\u4F9B\u670D\u52A1\u65F6\uFF0C\u53EF\u80FD\u4F1A\u6536\u96C6\u3001\u50A8\u5B58\u548C\u4F7F\u7528\u4E0B\u5217\u4E0E\u60A8\u6709\u5173\u7684\u8FD9\u4E9B\u4FE1\u606F\uFF1A\u60A8\u5728\u95EE\u5377\u62BD\u5956\u9875\u9762\u4E0A\u4E3B\u52A8\u8F93\u5165\u7684\u59D3\u540D\u3001\u8054\u7CFB\u65B9\u5F0F\u3001\u5730\u5740\uFF0C\u4EE5\u4FBF\u4E8E\u6211\u4EEC\u8FDB\u884C\u5956\u54C1\u53D1\u653E\u3002"), React.createElement("div", null, "2\u3001\u60A8\u9700\u8981\u6CE8\u610F\u7684\u662F\uFF1A\u4EE5\u4E0A\u4E2A\u4EBA\u4FE1\u606F\u5747\u662F\u60A8\u81EA\u613F\u63D0\u4F9B\uFF0C\u60A8\u6709\u6743\u62D2\u7EDD\u63D0\u4F9B\uFF0C\u4F46\u5982\u679C\u60A8\u4E0D\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\u6216\u8005\u63D0\u4F9B\u7684\u4FE1\u606F\u5E76\u975E\u771F\u5B9E\u6709\u6548\u7684\u4FE1\u606F\uFF0C\u53EF\u80FD\u65E0\u6CD5\u53C2\u4E0E\u672C\u6B21\u5956\u54C1\u8D60\u4E0E\u6D3B\u52A8\u3002"), React.createElement("div", null, "3\u3001\u6211\u4EEC\u5C06\u4E25\u683C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u3002\u6211\u4EEC\u5C06\u91C7\u7528\u9002\u5F53\u5236\u5EA6\u3001\u5B89\u5168\u6280\u672F\u548C\u7A0B\u5E8F\u7B49\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E0D\u88AB\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u4F7F\u7528\u6216\u6CC4\u6F0F\u3002\u6211\u4EEC\u4EA6\u5C06\u4FC3\u4F7F\u672C\u58F0\u660E\u6240\u8FF0\u5404\u63A5\u6536\u548C\u4F7F\u7528\u65B9\u5C3D\u529B\u4FDD\u62A4\u548C\u4E0D\u4E88\u6CC4\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002"), React.createElement("div", null, "4\u3001\u6211\u4EEC\u4F1A\u4E25\u683C\u8981\u6C42\u4E0A\u8FF0\u4E2A\u4EBA\u4FE1\u606F\u7684\u63A5\u6536\u65B9\u548C/\u6216\u4F7F\u7528\u65B9\u5E94\u9075\u5FAA\u672C\u58F0\u660E\u8C28\u614E\u8FDB\u884C\u6570\u636E\u7684\u4F7F\u7528\u3002\u5982\u8D85\u8D8A\u672C\u58F0\u660E\u8303\u56F4\uFF0C\u63A5\u6536\u65B9\u548C/\u6216\u4F7F\u7528\u65B9\u5E94\u5F53\u53E6\u884C\u5F81\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\uFF0C\u82E5\u56E0\u5176\u672A\u83B7\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\u81F4\u4F7F\u7528\u6237\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u4FB5\u5BB3\u7684\uFF0C\u8BE5\u4FE1\u606F\u63A5\u6536\u548C/\u6216\u4F7F\u7528\u65B9\u5E94\u627F\u62C5\u76F8\u5E94\u7684\u6CD5\u5F8B\u8D23\u4EFB\u3002", ' '), React.createElement("div", null, "5\u3001\u5982\u679C\u60A8\u9700\u8981\u67E5\u8BE2\u3001\u4FEE\u6539\u6216\u66F4\u6B63\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u6216\u5BF9\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u95EE\u9898\u6709\u4EFB\u4F55\u7591\u95EE\u6216\u6295\u8BC9\uFF0C\u60A8\u53EF\u4EE5\u5728\"\u53CD\u9988\u4E0E\u5E2E\u52A9\"\u4E2D\u8054\u7CFB\u6211\u4EEC\u3002", ' '), React.createElement("div", {
    style: {
      fontWeight: 500,
      color: '#161823'
    }
  }, "\u4E8C\u3001\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u7279\u6B8A\u4FDD\u62A4"), React.createElement("div", {
    style: {
      fontWeight: 500,
      color: '#161823'
    }
  }, "\u5BF9\u4E8E\u4E0D\u6EE1 18 \u5468\u5C81\u7684\u7528\u6237\uFF0C\u987B\u4E0E\u5176\u6CD5\u5B9A\u76D1\u62A4\u4EBA\u4E00\u540C\u9605\u8BFB\u3001\u7406\u89E3\u672C\u58F0\u660E\u5E76\u4E14\u7ECF\u76D1\u62A4\u4EBA\u540C\u610F\u8BB8\u53EF\u7684\u60C5\u51B5\u4E0B\u63D0\u4EA4\u4E2A\u4EBA\u4FE1\u606F\u3002"), React.createElement("div", {
    style: {
      fontWeight: 500,
      color: '#161823'
    }
  }, "\u4E09\u3001\u9002\u7528\u6CD5\u5F8B"), React.createElement("div", null, "1\u3001\u672C\u58F0\u660E\u9002\u7528\u6CD5\u5F8B\u3002"), React.createElement("div", {
    style: {
      fontWeight: 500,
      color: '#161823'
    }
  }, "\u56DB\u3001\u53D8\u66F4"), React.createElement("div", null, "\u6211\u4EEC\u4F1A\u9002\u65F6\u5BF9\u672C\u58F0\u660E\u8FDB\u884C\u4FEE\u8BA2\uFF0C\u8BE5\u7B49\u4FEE\u8BA2\u6784\u6210\u672C\u58F0\u660E\u7684\u4E00\u90E8\u5206\u3002\u672C\u516C\u53F8\u4F1A\u5C06\u4FEE\u6539\u540E\u7684\u58F0\u660E\u4E88\u4EE5\u53D1\u5E03\u3002\u5728\u8BE5\u79CD\u60C5\u51B5\u4E0B\uFF0C\u82E5\u60A8\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u670D\u52A1\uFF0C\u5373\u8868\u793A\u540C\u610F\u63A5\u53D7\u7ECF\u4FEE\u8BA2\u7684\u58F0\u660E\u7684\u7EA6\u675F\u3002"));
  var tipContent = React.createElement("div", {
    className: tipModalContCls
  }, React.createElement("div", {
    className: "title"
  }, "\u8BF7\u9605\u8BFB\u5E76\u540C\u610F", React.createElement("span", {
    style: {
      color: '#161823'
    }
  }, "\u300A\u4E2A\u4EBA\u4FE1\u606F\u6388\u6743\u58F0\u660E\u300B")), React.createElement("div", {
    className: "footer"
  }, React.createElement("div", {
    className: "btn cancel",
    onClick: closeTipModal
  }, "\u53D6\u6D88"), React.createElement("div", {
    className: "btn sure",
    onClick: function onClick() {
      onSubmit({
        state: true
      });
    }
  }, "\u540C\u610F\u5E76\u63D0\u4EA4")));
  var quitContent = React.createElement("div", {
    className: tipModalContCls
  }, React.createElement("div", {
    className: "title",
    style: {
      color: '#161823'
    }
  }, "\u5173\u95ED\u540E\u5C06\u65E0\u6CD5\u6536\u5230\u5956\u54C1\uFF0C\u786E\u8BA4\u5173\u95ED\u5417\uFF1F"), React.createElement("div", {
    className: "footer"
  }, React.createElement("div", {
    className: "btn cancel",
    onClick: function onClick() {
      closeQuitModal();
    }
  }, "\u53D6\u6D88"), React.createElement("div", {
    className: "btn sure",
    onClick: function onClick() {
      closeQuitModal();
      closeModal();
    }
  }, "\u786E\u8BA4")));
  var prizeCont = React.createElement(React.Fragment, null, React.createElement("div", {
    className: prizeImgCls
  }, React.createElement("img", {
    src: imgUrl
  }), React.createElement("div", {
    className: "shadow"
  })), React.createElement("div", {
    className: prizeCls
  }, React.createElement("div", {
    className: "cardTop"
  }, React.createElement("div", {
    className: "winText"
  }, "\u606D\u559C\u4F60\u83B7\u5F97", name, "\uFF01"), React.createElement("div", {
    className: "underline"
  }, React.createElement("img", {
    src: lineImg
  }))), React.createElement("div", {
    className: "cardBottom"
  }, type === 1 && React.createElement("div", {
    className: "cont"
  }, React.createElement("div", {
    style: {
      marginBottom: 16
    }
  }, "\u5361\u53F7\uFF1A", cardId), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      flex: 1
    }
  }, "\u5361\u5BC6\uFF1A", showSecret ? cardSecret : '**************************'), React.createElement("img", {
    style: {
      width: 20,
      marginLeft: 8
    },
    onClick: triggerSecret,
    src: showSecret ? openEyeImg : closeEyeImg
  }))), type === 2 && React.createElement("div", {
    className: "cont",
    style: {
      padding: '0 16px'
    }
  }, React.createElement("p", {
    style: {
      marginBottom: 8
    }
  }, "\u4F7F\u7528\u8BF4\u660E\uFF1A"), React.createElement("p", {
    style: {
      marginBottom: 6
    }
  }, "1.\u67E5\u770B\u65B9\u5F0F\uFF08\u4EE5\u4E0B\u65B9\u5F0F\u5747\u53EF\u67E5\u770B\uFF09:"), React.createElement("p", {
    style: {
      marginLeft: 14
    }
  }, "a. \u53F3\u4E0B\u89D2-\u6211\u7684\u94B1\u5305-\u5361\u5238\u4E2D\u67E5\u770B\uFF1B"), React.createElement("p", {
    style: {
      marginLeft: 14
    }
  }, "b. \u5546\u57CE-\u5238/\u7EA2\u5305\u4E2D\u67E5\u770B\uFF1B"), React.createElement("p", {
    style: {
      marginTop: 6
    }
  }, "2.\u53EF\u5728\u8D2D\u7269\u65F6\u4F7F\u7528\u3002")), type === 0 && React.createElement("div", {
    className: "btn",
    onClick: writeInfo
  }, "\u586B\u5199\u5730\u5740"), type === 1 && React.createElement(CopyToClipboard, {
    text: "\u5361\u53F7\uFF1A".concat(cardId, ";\u5361\u5BC6\uFF1A").concat(cardSecret),
    onCopy: function onCopy() {
      _Toast.show({
        icon: 'success',
        content: '复制成功',
        maskClassName: 'lotteryToast',
        duration: 3
      });
    }
  }, React.createElement("div", {
    className: "btn"
  }, "\u590D\u5236\u5361\u53F7\u5361\u5BC6")), React.createElement("div", {
    className: "tips"
  }, "\u8BF7\u622A\u56FE\u4FDD\u5B58\u54E6~"), React.createElement("img", {
    src: closeImg,
    className: "close",
    onClick: closeModal
  }))));
  var userInfoCont = React.createElement(React.Fragment, null, successTip ? React.createElement("div", {
    className: successContCls
  }, React.createElement("img", {
    src: successImg
  }), React.createElement("div", {
    className: "text"
  }, "\u5730\u5740\u63D0\u4EA4\u6210\u529F"), React.createElement(_Button, {
    color: "primary",
    onClick: closeModal
  }, "\u6211\u77E5\u9053\u4E86")) : React.createElement(React.Fragment, null, React.createElement(_Form, {
    className: formCls,
    layout: "horizontal",
    form: form
  }, React.createElement("div", {
    className: "formHeader"
  }, React.createElement("div", {
    className: "title"
  }, "\u586B\u5199\u90AE\u5BC4\u5730\u5740"), React.createElement("img", {
    src: closeIcon,
    onClick: openQuitModal
  })), React.createElement(_Form.Item, {
    name: "username",
    label: React.createElement(React.Fragment, null, React.createElement("div", null, "\u59D3"), React.createElement("div", null, "\u540D")),
    rules: [{
      required: true,
      message: '请输入姓名'
    }]
  }, React.createElement(_Input, {
    clearable: true,
    autoComplete: "off",
    placeholder: "\u8BF7\u8F93\u5165\u59D3\u540D"
  })), React.createElement(_Form.Item, {
    name: "phone",
    label: "\u624B\u673A\u53F7\u7801",
    validateTrigger: "onBlur",
    rules: [{
      validator: checkMobile
    }]
  }, React.createElement(_Input, {
    clearable: true,
    autoComplete: "off",
    placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801"
  })), React.createElement(_Form.Item, {
    label: "\u9009\u62E9\u5730\u533A"
    // rules={[{ required: true, message: '请选择地区' }]}
    ,
    className: hasError && 'adm-form-item-has-error'
  }, React.createElement("div", {
    className: "cascaderSel",
    onClick: openCascader,
    style: {
      color: location.length ? '#161823' : 'rgba(22, 24, 35, 0.6)'
    }
  }, location.length ? location.join('') : '请选择地区'), React.createElement("div", {
    className: "arrow"
  })), hasError && React.createElement("div", {
    className: "adm-form-item-feedback-error",
    style: {
      fontSize: 13,
      marginLeft: 82
    }
  }, "\u8BF7\u9009\u62E9\u5730\u533A"), React.createElement(_Form.Item, {
    name: "address",
    label: "\u8BE6\u7EC6\u5730\u5740",
    rules: [{
      required: true,
      message: '请填写详细地址'
    }]
  }, React.createElement(_Input, {
    clearable: true,
    autoComplete: "off",
    placeholder: "\u8BF7\u586B\u5199\u8BE6\u7EC6\u5730\u5740"
  })), React.createElement(_Button, {
    color: "primary",
    className: "btn",
    onClick: onSubmit
  }, "\u63D0\u4EA4"), React.createElement("div", {
    className: "protocolCont"
  }, React.createElement(Checkbox, {
    style: {
      '--icon-size': '18px',
      '--font-size': '14px',
      '--gap': '6px',
      color: 'rgba(22, 24, 35, 0.6)'
    },
    checked: checkState,
    onChange: function onChange(e) {
      setCheckState(e.target.checked);
    }
  }, "\u52FE\u9009\u6B64\u6846\u8868\u793A\u540C\u610F"), React.createElement("span", {
    className: "statement",
    onClick: openStateModal
  }, "\u300A\u4E2A\u4EBA\u4FE1\u606F\u6388\u6743\u58F0\u660E\u300B"))), React.createElement(_Popup, {
    visible: stateModal,
    bodyStyle: {
      height: '60vh',
      overflow: 'auto'
    }
  }, stateContent), React.createElement(_Popup, {
    visible: tipModal
  }, tipContent), React.createElement(_Popup, {
    visible: quitModal
  }, quitContent)));
  return React.createElement(React.Fragment, null, React.createElement(_Modal, {
    actions: [],
    visible: true,
    alignCenter: true,
    content: infoModal ? userInfoCont : prizeCont
  }));
}
var prizeImgCls = /*#__PURE__*/css("position:absolute;top:-40px;left:50%;margin-left:-40px;width:80px;height:80px;padding:16px 20px;border:1px solid rgba(22,24,35,0.12);border-radius:50%;background:#fff;z-index:9999;.shadow{width:28px;margin:auto;height:4px;margin-top:8px;background:rgba(22,65,138,0.12);filter:blur(2px);}");
var prizeCls = /*#__PURE__*/css(".cardTop{.winText{margin-top:56px;margin-bottom:16px;text-align:center;font-weight:500;font-size:16px;color:#03081a;}.underline{position:relative;padding:0 16px;height:16px;line-height:16px;overflow:hidden;img{position:absolute;top:50%;transform:translateY(-50%);}&::before,&::after{content:'';width:16px;height:16px;position:absolute;top:0;border-radius:50%;background:#6d747e;}&::before{left:-8px;}&::after{right:-8px;}}}.cardBottom{padding:16px;color:#03081a;font-size:15px;.cont{padding:0 24px;margin-bottom:40px;}.btn{margin:16px 8px 24px 8px;padding:12px 0;text-align:center;background:#168ef9;border-radius:8px;color:#fff;font-weight:500;}.tips{color:#fe2c55;text-align:center;font-size:14px;}.close{width:24px;position:absolute;left:50%;margin-left:-12px;bottom:-48px;}}.adm-modal-content{padding:0;}.semi-banner-icon{margin-right:8px;.semi-icon{position:relative;top:2px;}}.index-module_content__3wvrm{padding:6px 12px 40px 12px !important;}");
var formCls = /*#__PURE__*/css("padding:32px 16px 16px;max-height:70vh;overflow:auto;.formHeader{margin-bottom:28px;text-align:center;font-size:17px;font-weight:500;img{position:fixed;top:12px;right:12px;width:28px;z-index:9999;}}.cascaderSel{width:calc(100vw - 164px);font-size:15px;flex:1 1 0%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.arrow{display:block;width:10px;height:10px;margin-left:8px;background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACcSURBVHgBrc5LCsIwEAbgf5yVmE1RyF5EL9OexqO1pyniPiC6ikujkZa+8mhDfwhkhpmPAVYOSXkqDExOoEqpW4mE9A3eieza9M9C7EnrZ52CtQZvRYaffElBRxg+MCW/9atOQV3YQ90rtsVS1IfZP7fNuWgIG4Bz0BhmQ3DkII/5BlR0Q/RfimGTC0OXNi+IeUEPGsWCoAuNYTZfooGJDfDKcYYAAAAASUVORK5CYII=');background-size:contain;background-repeat:no-repeat;background-position:50% 50%;transform:rotate(-90deg);}.protocolCont{margin-top:16px;display:flex;align-items:center;font-size:14px;.statement{display:inline-block;color:#168ef9;}.am-checkbox-wrapper{display:flex;align-items:center;color:rgba(22,24,35,0.6);}.am-checkbox{width:18px;height:18px;margin-right:8px;}.am-checkbox-inner{width:18px;height:18px;border-radius:4px;border:1.5px solid rgba(22,24,35,0.34);}.am-checkbox.am-checkbox-checked .am-checkbox-inner{border:0 !important;background:#168ef9 !important;&::after{top:3px;right:6px;width:6px;}}}.adm-list-item{padding-left:0;}.adm-list-body{border:0 !important;}.adm-list-item-content{border-top:0;margin-bottom:8px;padding-right:0;}.adm-list-item-content-prefix{width:82px;padding:0 !important;border-bottom:0 !important;}.adm-form-item-label{width:62px;display:flex;line-height:52px;justify-content:space-between;font-size:15px;color:#161823;}.adm-form-item-has-error{.adm-form-item-child-inner{border-bottom:1px solid #fe2c55;}}.adm-form-item-child-inner{display:flex;align-items:center;height:52px;line-height:52px;border-bottom:1px solid rgba(22,24,35,0.12);overflow:hidden;}.adm-form-item-feedback-error{color:#fe2c55;}.adm-list-item-content-main{padding:0 !important;}.adm-input{line-height:52px;height:52px;font-size:15px;color:#161823;.adm-input-element{font-size:15px;}}.adm-form-item-required-asterisk{display:none;}.adm-button{width:100%;padding:12px 0px;margin:16px 0;background:#168ef9;border-radius:8px;border:0;font-weight:500;font-size:15px;}");
var stateModalContCls = /*#__PURE__*/css("padding:0 16px;line-height:24px;color:rgba(22,24,35,0.75);.title{margin:18px 0;font-weight:500;font-size:17px;color:#161823;}img{width:28px;position:absolute;top:16px;right:16px;}div{margin-bottom:16px;}");
var tipModalContCls = /*#__PURE__*/css("font-size:14px;.title{padding:20px;text-align:center;color:rgba(22,24,35,0.6);border-bottom:1px solid rgba(22,24,35,0.12);}.footer{display:flex;align-items:center;.btn{flex:1;text-align:center;padding:14px;color:rgba(22,24,35,0.75);font-size:15px;}.cancel{border-right:1px solid rgba(22,24,35,0.12);}.sure{color:#168ef9;font-weight:500;}}");
var successContCls = /*#__PURE__*/css("text-align:center;padding:20px;img{width:60px;}.text{margin:24px 0;font-weight:500;font-size:17px;color:#161823;}.adm-button{width:100%;padding:12px 0px;background:#168ef9;border-radius:8px;border:0;font-weight:500;font-size:15px;}");